/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ReactNode, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSearchParams } from 'react-router-dom'
import SharedData from '../common/SharedData'
import NormalMessage from '../common/NormalMessage'
import Loader from '../common/Loader'
import { prepareFilters } from '../orders/core/_requests'
import { getPickupFeesList } from './core/_requests'
import PickupFeesReportTable from './pickup-fees/PickupFeesReportTable'
import PickupFeesReportFilters from './pickup-fees/PickupFeesReportFilters'
import { IPickupFeesReportModel } from './core/_models'

interface ITotalPickupFeesRow {
    total_pickups_count: number
    total_pickups_fees: number
}

const PickupFeesReport: React.FC<{ className?: string }> = ({ className }) => {
    const { formatMessage } = useIntl()
    const [searchParams, setSearchParams] = useSearchParams()
    const { currentUser, language } = SharedData()
    const [dataList, setDataList] = useState<IPickupFeesReportModel[]>([])
    const [pickupFeesTotal, setPickupFeesTotal] = useState<ITotalPickupFeesRow | null>(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        prepareFilters(searchParams, setSearchParams)

        const fetchData = async () => {
            try {
                setIsLoading(true)
                const queryParams = document.location.search
                const res = await getPickupFeesList(queryParams, currentUser?.token, language)

                setDataList(res.data.po_pickup_fees_list)
                setPickupFeesTotal({
                    total_pickups_count: res.data.po_pickup_fees_list.length,
                    total_pickups_fees: res.data.total_pickup_fees,
                })
            } catch (exp: any) {
                console.error(exp)
            }
            setIsLoading(false)
        }

        fetchData()
    }, [searchParams, currentUser?.token, language])

    const renderResults = (): ReactNode => {
        if (isLoading) {
            return <Loader />
        }

        if (dataList.length > 0) {
            return (
                <div className="card-body py-3">
                    <PickupFeesReportTable data={dataList} pickupFeesTotal={pickupFeesTotal} />
                </div>
            )
        }

        return <NormalMessage msg={formatMessage({ id: 'no_data' })} />
    }

    return (
        <div className={`card ${className}`}>
            <div className="card-header border-0 pt-5">
                <h3 className="card-title align-items-start flex-column">
                    {formatMessage({ id: 'pickup_fees_report' })}
                </h3>
            </div>
            <PickupFeesReportFilters />
            {renderResults()}
        </div>
    )
}

export { PickupFeesReport }
